import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styles from "./Home.module.scss";
import classNames from "classnames/bind";
import { createAxios } from "../../../createInstance";
import { loginSuccess } from "../../../redux/authSlice";
import {
    getAllCustomers,
    createCustomer,
    updateCustomer,
    deleteCustomer,
} from "../../../redux/apiRequest";
import ToastMessage, { showToast } from "../../../Components/ToastMessage";

const cx = classNames.bind(styles);

const Home = () => {
    const [showModal, setShowModal] = useState(false);
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [email, setEmail] = useState("");
    const [logo, setLogo] = useState(null);
    const [currentId, setCurrentId] = useState(null);

    const user = useSelector((state) => state.auth.login.currentUser);
    const customers = useSelector((state) => state.customer.customers?.allCustomers);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const axiosJWT = createAxios(user, dispatch, loginSuccess,navigate );



    const handleAdd = () => {
        setCurrentId(null);
        setName("");
        setAddress("");
        setEmail("");
        setLogo(null);
        setShowModal(true);
    };

    const handleEdit = (customer) => {
        setCurrentId(customer._id);
        setName(customer.businessName || "");
        setAddress(customer.businessAddress || "");
        setEmail(customer.businessEmail || "");
        setLogo(null);
        setShowModal(true);
    };

    const handleDelete = (id) => {
        const successCallback = () => {
            showToast({
                type: "success",
                title: "Thành công!",
                message: "Bạn đã xóa khách hàng thành công.",
                duration: 3000
            })
        }
        const failedCallback = () => {
            showToast({
                type: "error",
                title: "Thất bại!",
                message: "Xóa khách hàng thất bại, vui lòng thử lại sau.",
                duration: 3000
            })
        }
        if (user) {
            deleteCustomer(id, user.accessToken, dispatch, axiosJWT, successCallback, failedCallback);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!user) return;
        const formData = new FormData();
        formData.append("businessName", name);
        formData.append("businessAddress", address);
        formData.append("businessEmail", email);
        if (logo) {
            formData.append("businessLogo", logo);
        }
        if (currentId) {
            const successCallback = () => {
                showToast({
                    type: "success",
                    title: "Thành công!",
                    message: "Bạn vừa cậpt nhật một khách hàng trong danh sách.",
                    duration: 3000
                })
            }
            const failedCallback = () => {
                showToast({
                    type: "error",
                    title: "Thất bại!",
                    message: "Cập nhật khách hàng thất bại, vui lòng thử lại.",
                    duration: 3000
                })
            }
            updateCustomer(currentId, formData, user.accessToken, dispatch, axiosJWT, successCallback, failedCallback);
        } else {
            const successCallback = () => {
                showToast({
                    type: "success",
                    title: "Thành công!",
                    message: "Bạn vừa thêm một khách hàng vào danh sách.",
                    duration: 3000
                })
            }
            const failedCallback = () => {
                showToast({
                    type: "error",
                    title: "Thất bại!",
                    message: "Thêm khách hàng thất bại, vui lòng thử lại.",
                    duration: 3000
                })
            }
            createCustomer(formData, user.accessToken, dispatch, axiosJWT, successCallback, failedCallback);
        }
        setShowModal(false);
    };

    useEffect(() => {
        if (user) {
            getAllCustomers(user.accessToken, dispatch, axiosJWT);
        }
    }, []);

    return (
        <main className={cx("main")}>
            <div className={cx("header")}>
                <h1 className={cx("title")}>Customers</h1>
                <button className={cx("add-button")} onClick={handleAdd}>
                    Add
                </button>
            </div>
            <div className={cx("customer-list")}>
                {customers.map((customer) => (
                    <div
                        key={customer._id}
                        className={cx("customer-card")}
                        onClick={() => navigate(`/admin/customer/${customer.slug}`)}
                    >
                        <img src={customer.businessLogo} alt={customer.businessName} className={cx("customer-logo")} />
                        <span className={cx("customer-name")}>{customer.businessName}</span>
                        <div className={cx("card-actions")}>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEdit(customer);
                                }}
                                className={cx("edit-button")}
                            >
                                Edit
                            </button>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete(customer._id);
                                }}
                                className={cx("delete-button")}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {showModal && (
                <div className={cx("modal-overlay")} >
                    <div className={cx("modal")} onClick={(e) => e.stopPropagation()}>
                        <h2 className={cx("modal-title")}>{currentId ? "Edit Customer" : "Add Customer"}</h2>
                        <form className={cx("form")} onSubmit={handleSubmit}>
                            <label className={cx("label")}>
                                Name
                                <input type="text" className={cx("input")} value={name} onChange={(e) => setName(e.target.value)} />
                            </label>
                            <label className={cx("label")}>
                                Address
                                <input type="text" className={cx("input")} value={address} onChange={(e) => setAddress(e.target.value)} />
                            </label>
                            <label className={cx("label")}>
                                Logo
                                <input type="file" className={cx("input")} onChange={(e) => setLogo(e.target.files[0])} />
                            </label>
                            <label className={cx("label")}>
                                Email
                                <input type="email" className={cx("input")} value={email} onChange={(e) => setEmail(e.target.value)} />
                            </label>
                            <div className={cx("actions")}>
                                <button type="button" className={cx("cancel-button")} onClick={() => setShowModal(false)}>
                                    Cancel
                                </button>
                                <button type="submit" className={cx("submit-button")}>Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            <ToastMessage />
        </main>
    );
};

export default Home;
